exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-area[data-v-6acfb096] {\n  padding: 10px 0 20px;\n}\n.pagination-wrap[data-v-6acfb096] {\n  text-align: right;\n  padding: 30px 20px;\n}\n.template-scope-wrap[data-v-6acfb096] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n", ""]);

// exports
